import { useTranslation } from 'react-i18next';

import { Button } from '@saas-kit/ui';

interface Props {
  isCreate: boolean;
  editable: boolean;
  isPending: boolean;
  showSaved: boolean;
  canSave: boolean;
  onSave: () => void;
  onCancelCreate: () => void;
}

export function RoleEditorFooter({
  isCreate,
  editable,
  isPending,
  showSaved,
  canSave,
  onSave,
  onCancelCreate,
}: Props): JSX.Element {
  const { t } = useTranslation('rbac');

  return (
    <div className="flex items-center justify-end gap-2 border-t border-border pt-3">
      {showSaved ? (
        <span className="me-auto text-xs text-emerald-700">{t('editor.saved')}</span>
      ) : null}
      {isCreate ? (
        <Button variant="secondary" onClick={onCancelCreate}>
          {t('editor.cancel')}
        </Button>
      ) : null}
      {editable ? (
        <Button onClick={onSave} disabled={!canSave || isPending}>
          {isPending ? t('editor.saving') : t('editor.save')}
        </Button>
      ) : null}
    </div>
  );
}
